/** CARGO-L3: UI reads lifecycle projection API instead of legacy allocation math. */
export function isCargoLifecycleProjectionUiEnabled(): boolean {
  const v = process.env.REACT_APP_CARGO_LIFECYCLE_PROJECTION_UI;
  if (v === 'false') return false;
  return v === 'true' || v === '1';
}
